import { render, staticRenderFns } from "./wxhhTable.vue?vue&type=template&id=231b74da&scoped=true"
import script from "./wxhhTable.vue?vue&type=script&lang=ts"
export * from "./wxhhTable.vue?vue&type=script&lang=ts"
import style0 from "./wxhhTable.vue?vue&type=style&index=0&id=231b74da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b74da",
  null
  
)

export default component.exports